import { useLoaderData } from 'react-router-dom';
import * as Icon from 'react-bootstrap-icons';

import { useMedico } from './hooks/useMedico';
import { useValidar } from './hooks/useValidar';
import { useActivar } from './hooks/useActivar';

import { Acordion, Error, Loader, MedicoStatus, PrimaryButton, TextInputPreview } from '../../components';
import { Consultorio } from './components/Consultorio';

import styles from './MedicoView.module.css';
import { colors } from '../../types/types';

export async function loader({ params }) {
    return params.id;
}

export const MedicoView = () => {

    const id = useLoaderData();

    const { medicoQuery: { isLoading: isLoadingMedico, isError: isErrorMedico, data: medico } } = useMedico(id);

    const { validarMutation: { mutate: validar } } = useValidar({ id });
    
    const { activarMutation: { mutate: activar } } = useActivar({ id });

    const handleValidar = (id, value) => {
        validar({ id, value });
    }

    const handleActivar = (id, value) => {
        activar({ id, value });
    }

    return <>
        {(isLoadingMedico)
            ? <Loader />
            : <>
            {(isErrorMedico)
                ? <Error />
                : <>
                    <div className="row">
                        <div className="col">
                            <div className={styles.panelSection + " " + styles.panelNoHeader}>
                                <div className="row">
                                    <div className="col-md-12 col-lg-8">
                                        <div className="row">
                                            <div className="col-md-12 col-lg-6">
                                                <div className={styles.panel}>
                                                    <div className="row">
                                                        <div className="col">
                                                            <div className={styles.resumenHeader}>Status general</div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col">
                                                            <TextInputPreview
                                                                label=""
                                                                name="appMovil"
                                                                value={<div>
                                                                    <div>
                                                                        <MedicoStatus
                                                                            email={medico.emailVerification}
                                                                            validado={medico.validado}
                                                                            activo={medico.activo}
                                                                            steps={[
                                                                                { color: (medico.emailVerification) ? '#7FAE1B' : '#6C757D' }, // Punto 1
                                                                                { color: (medico.emailVerification && medico.validado ) ? '#7FAE1B' : '#6C757D' },
                                                                                { color: (medico.validado) ? '#7FAE1B' : '#6C757D' }, // Punto 2
                                                                                { color: (medico.validado && medico.activo) ? '#7FAE1B' : '#6C757D' },
                                                                                { color: (medico.activo) ? '#7FAE1B' : '#6C757D' },    // Punto 3
                                                                            ]}
                                                                        />
                                                                    </div>
                                                                </div>}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col">
                                                            <PrimaryButton
                                                                block={true}
                                                                inverse={true}
                                                                marginTop={false}
                                                                onClick={() => handleValidar(id, !medico.validado)}
                                                                text={(medico.validado) ? 'Invalidar' : 'Validar'}
                                                                type="button"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="row mt-3">
                                                        <div className="col">
                                                            <PrimaryButton
                                                                block={true}
                                                                inverse={true}
                                                                marginTop={false}
                                                                onClick={() => handleActivar(id, !medico.activo)}
                                                                text={(medico.activo) ? 'Inactivar' : 'Activar'}
                                                                type="button"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-12 col-lg-3">
                                                <div className={styles.panel}>
                                                    <div className="row">
                                                        <div className="col">
                                                            <div className={styles.resumenHeader}>Suscripción</div>
                                                            <div className={styles.suscripcionContainer}>
                                                                <div className={styles.iconSuscripcionContainer}><Icon.BookmarkStar color={colors.PRIMARY} size={20} /></div>
                                                                <div>
                                                                    <div className={styles.textHeaderSuscripcionContainer}>{ medico.suscripcion.suscripcionStr }</div>
                                                                    <div className={styles.textSubheaderSuscripcionContainer}>{(medico.suscripcion.suscripcionActiva) ? 'Validez: ' + medico.suscripcion.fechaFinFormato : 'Caduca'}</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-12 col-lg-3">
                                                <div className={styles.panel}>
                                                    <div className={styles.resumenHeader}>Números de cedulas</div>
                                                    <TextInputPreview
                                                        label="Médicina general"
                                                        name="numeroMedicinaGeneral"
                                                        value={<div className={styles.resumenText}><div>{medico.numeroMedicinaGeneral}</div></div>}
                                                    />
                                                    <TextInputPreview
                                                        label="Especialidad"
                                                        name="numeroEspecialidad"
                                                        value={<div className={styles.resumenText}><div>{medico.numeroEspecialidad}</div></div>}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-12 col-lg-4">
                                        <div className={styles.panelDivider}>
                                            <div className="row h-100">
                                                <div className="col h-100">
                                                    {(medico.identificacionOficial !== null && medico.constanciaSituacionProfesional !== null) &&
                                                    <div className={styles.panelHeader}>Archivos Generales</div>
                                                    }
                                                    {(medico.identificacionOficial !== null) &&
                                                    <div className="row">
                                                        <div className="col">
                                                            <TextInputPreview
                                                                label="Identificación oficial"
                                                                name="identificacionOficial"
                                                                value={<a className={styles.customFilePreview} href={medico.identificacionOficial}>{ medico.identificacionOficialName }</a>}
                                                            />
                                                        </div>
                                                    </div>
                                                    }
                                                    {(medico.constanciaSituacionProfesional !== null) &&
                                                    <div className="row">
                                                        <div className="col">
                                                            <TextInputPreview
                                                                label="Constancia de situación profesional"
                                                                name="constanciaSituacionProfesional"
                                                                value={<a className={styles.customFilePreview} href={medico.constanciaSituacionProfesional}>{ medico.constanciaSituacionProfesionalName }</a>}
                                                            />
                                                        </div>
                                                    </div>
                                                    }
                                                    {(medico.cedulaMedicinaGeneral !== null && medico.cedulaEspecialidad !== null && medico.cedulaAlergia !== null && medico.cedulaConsejoAlergia !== null) &&
                                                    <div className={styles.panelHeader}>Cédulas</div>
                                                    }
                                                    {(medico.cedulaMedicinaGeneral !== null) &&
                                                    <div className="row">
                                                        <div className="col">
                                                            <TextInputPreview
                                                                label="Medicina general"
                                                                name="medicinaGeneral"
                                                                value={<a className={styles.customFilePreview} href={medico.cedulaMedicinaGeneral}>{ medico.cedulaMedicinaGeneralName }</a>}
                                                            />
                                                        </div>
                                                    </div>
                                                    }
                                                    {(medico.cedulaEspecialidad !== null) &&
                                                    <div className="row">
                                                        <div className="col">
                                                            <TextInputPreview
                                                                label="Especialidad"
                                                                name="especialidad"
                                                                value={<a className={styles.customFilePreview} href={medico.cedulaEspecialidad}>{ medico.cedulaEspecialidadName }</a>}
                                                            />
                                                        </div>
                                                    </div>
                                                    }
                                                    {(medico.cedulaAlergia !== null) &&
                                                    <div className="row">
                                                        <div className="col">
                                                            <TextInputPreview
                                                                label="Alergia"
                                                                name="alergia"
                                                                value={<a className={styles.customFilePreview} href={medico.cedulaAlergia}>{ medico.cedulaAlergiaName }</a>}
                                                            />
                                                        </div>
                                                    </div>
                                                    }
                                                    {(medico.cedulaConsejoAlergia !== null) &&
                                                    <div className="row">
                                                        <div className="col">
                                                            <TextInputPreview
                                                                label="Consejo alergia"
                                                                name="consejoAlergia"
                                                                value={<a className={styles.customFilePreview} href={medico.cedulaConsejoAlergia}>{ medico.cedulaConsejoAlergiaName }</a>}
                                                            />
                                                        </div>
                                                    </div>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className={styles.panelSection + " " + styles.panelNoHeader}>
                                <div className={styles.subHeader}>Datos Generales</div>
                                <div className="row">
                                    <div className="col-md-12 col-lg-3">
                                        <TextInputPreview
                                            label="Nombre"
                                            name="medico"
                                            value={`${ medico.nombre }${ (typeof medico.apellidoPaterno !== 'undefined' && medico.apellidoPaterno !== '') ? ' ' + medico.apellidoPaterno : '' }${ (typeof medico.apellidoMaterno !== 'undefined' && medico.apellidoMaterno !== '') ? ' ' + medico.apellidoMaterno : '' }`}
                                        />
                                    </div>
                                    <div className="col-md-4 col-lg-3">
                                        <TextInputPreview
                                            label="Fecha de nacimiento"
                                            name="fechaNacimiento"
                                            value={medico.fechaNacimientoFormato}
                                        />
                                    </div>
                                    <div className="col-md-4 col-lg-3">
                                        <TextInputPreview
                                            label="Edad"
                                            name="edad"
                                            value={medico.edad}
                                        />
                                    </div>
                                    <div className="col-md-4 col-lg-3">
                                        <TextInputPreview
                                            label="Género"
                                            name="genero"
                                            value={medico.genero}
                                        />
                                    </div>
                                    <div className="col-md-12 col-lg-3">
                                        <TextInputPreview
                                            label="Correo electrónico"
                                            name="email"
                                            value={medico.email}
                                        />
                                    </div>
                                    <div className="col-md-4 col-lg-3">
                                        <TextInputPreview
                                            label="Celular"
                                            name="celular"
                                            value={medico.celular}
                                        />
                                    </div>
                                    <div className="col-md-4 col-lg-3">
                                        <TextInputPreview
                                            label="Especialidad"
                                            name="especialidad"
                                            value={medico.especialidad}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className={styles.panelSection}>
                                <div className="row">
                                    <div className="col">
                                        <Acordion
                                            body={<>
                                                {medico.consultorios.map(consultorio => <Consultorio key={consultorio._id} consultorio={consultorio} />)}
                                            </>}
                                            header={<div className={styles.subHeader}>Consultorios</div>}
                                            id='pacienteViewOtrosAcordeon'
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            }
            </>
        }
        </>
}
